const Spacing = {
  Base: '8px',
  Medium: '16px',
  Large: '24px',
  Close: '0px',
  Separate: '40px',
  sidebarWidth: '324px',
};

export default Spacing;
